import errorReducer from "./reducer"
import errorsSaga from "./sagas"

const saga = {
  reducers: errorReducer,
  sagas: errorsSaga
}

export default saga